/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';

import { useSelector } from 'react-redux';
import { Selectors } from 'store/ducks/layoutProgressBar';

const PagesProgressBar = React.memo(() => {
  const progressPercentage = useSelector(Selectors.getProgressPercentage);

  return (
    <div
      id="LayoutProgressBar"
      className={`layout-progress-bar ${progressPercentage >= 100 || progressPercentage === 0 ? 'no-opacity' : ''}`}
      style={{ width: `${progressPercentage}%` }}
    />
  );
});

export default PagesProgressBar;
